export default "__VITE_ASSET__BbESnwMn__"